import { render, staticRenderFns } from "./MenuList.vue?vue&type=template&id=ec436490&scoped=true"
import script from "./MenuList.vue?vue&type=script&lang=ts"
export * from "./MenuList.vue?vue&type=script&lang=ts"
import style0 from "./MenuList.vue?vue&type=style&index=0&id=ec436490&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec436490",
  null
  
)

export default component.exports